import React, { useRef } from 'react';
import { PageContainer } from '@ant-design/pro-layout';
import useHasScopeTypes from '../../hooks/useHasScopeType';
import Main from '../layout/Main';
import ProjectsTable from './components/ProjectsTable';
import AddProjectModal from './components/AddProjectModal';

const Projects = () => {
  const { hasScopeType, loading: hasScopeTypeLoading } = useHasScopeTypes(
    'VIEW_ALL_PROJECT'
  );
  const actionRef = useRef();

  return (
    <Main>
      <PageContainer
        ghost
        loading={hasScopeTypeLoading}
        header={{ title: 'Projects' }}
        extra={[
          <AddProjectModal
            key="addhasScopeType-project-modal"
            actionRef={actionRef}
          />,
        ]}
      >
        <ProjectsTable canViewAll={hasScopeType} actionRef={actionRef} />
      </PageContainer>
    </Main>
  );
};

export default Projects;
